// removed by extract-text-webpack-plugin
module.exports = {"closeButton":"_3No4S","page":"_2vQgS","title":"_3HAUe","description":"_2zNj0","loginButtonContainer":"_3aDWi"};


//////////////////
// WEBPACK FOOTER
// ./app/components/login-screen/login-screen.scss
// module id = 945
// module chunks = 3 4 5 6 7